/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import moment from "moment";
import LocationOffIcon from '@mui/icons-material/LocationOff';
import { LocalGasStation, Speed } from '@mui/icons-material';

import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import AutoComplete2 from "../../../components/form/AutoComplete2";
import { PageSize } from "../../../config/const"

import Layout from "../../../components/layout/Layout";
import InputText from "../../../components/form/InputText";
import InputTextDetail from "../../../components/form/InputTextDetail";
import InputGroup from '../../../components/form/InputGroup';
import DatePickerUi from "../../../components/form/DatePickerUi";
import Autocomplete from "../../../components/form/AutoComplete";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton"
import TransportModal from './TransportModal';
import DriverModal from './DriverModal';
import MapToNew from "../../../components/map/MapToNew"
import MapOne from "../../../components/map/Map"
import Graf from "./Graf";
import validator from "./validator";
import SaveIcon from '@mui/icons-material/Save';

import { calculateKilometers, roundPrice } from '../../../config/hook/calculateKilometer';
import { getDeliveryPoint } from "../../../store/masters/thunk/deliveryPoint/getAll";
import { getTransport } from "../../../store/masters/thunk/transport/getAll";
import { getDriver } from "../../../store/masters/thunk/driver/getAll";
import { getClient } from "../../../store/masters/thunk/client/getAll"
import { postRoute } from "../../../store/transactions/thunk/route/post"
import { postRouteReset } from "../../../store/transactions/actions/route/post";
import { getRouteIdDPStart } from "../../../store/transactions/thunk/route/getDPStartAll";
import { getRouteIdDPEnd } from "../../../store/transactions/thunk/route/getDPEndAll";
import { getFuel } from "../../../store/masters/thunk/fuel/getAll";

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("route");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" });
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const [km, setKm] = useState(null);
    const [isMount, setIsMount] = useState(false);

    const [selectedClient, setSelectedClient] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("");
    const [selectedTonnelage, setSelectedTonnelage] = useState("");
    const [selectedDpStart, setSelectedDpStart] = useState("");
    const [selectedMunicipally, setSetlectedMunicipally] = useState("");
    const [selectedDpEnd, setSelectedDpEnd] = useState("");
    const [totalFuel, setTotalfuel] = useState(0);
    const [kmEstimate, setKmEstimate] = useState(0);

    const user = useSelector(state => state.auth.login.dataUser);
    const fuel = useSelector(state => state.masters.fuel);
    const current = useSelector(state => state.transactions.route.detail);
    const put = useSelector(state => state.transactions.route.put);
    const post = useSelector(state => state.transactions.route.post);
    const deliveryPointStart = useSelector(state => state.transactions.route.deliveryPointStart);
    const deliveryPointEnd = useSelector(state => state.transactions.route.deliveryPointEnd);
    const clientsRoute = useSelector(state => state.masters.client);

    const userData = JSON.parse(localStorage.getItem('userData'));
    const routeStatus = __(`routeStatus`, { returnObjects: true });
    const fuelCost = useRef({ kiloXGallon: 0, priceFuel: 0, kms: 0, gal: 0, cost: 0 });

    const divisions = map(userData?.divisions, ({ divisionId, divisionName }) => ({
        value: divisionId,
        label: divisionName,   
         }));

    const transportTypes = map(userData?.transportTypes, ({ idTransportType, description }) => ({
        value: idTransportType,
        label: description,   
        }));

    const clients = map(
        get(clientsRoute, "data.data", []).filter(c => get(c, "isActive") === "ACTIVO"),
        ({ customerId, name }) => ({
            value: customerId,
            label: `${customerId} - ${name}`,
        })
    );

    const deliveryPointsStart = map(deliveryPointStart?.data, ({ idDeliveryPoint, deliveryName }) => ({
            value: idDeliveryPoint,
            label: `${deliveryName}`,
        }));

    const deliveryPointsEnd = map(deliveryPointEnd?.data, ({ idDeliveryPoint, deliveryName }) => ({
        value: idDeliveryPoint,
        label: `${deliveryName}`,
    }));

    const routesTypes = map(userData?.routesTypes, ({ idRouteType, description }) => ({
            value: idRouteType,
            label: description,
    }));

    const [openModal, setOpenModal] = useState({
        transport: false,
        driver: false,
        formik: "",
    });

    const [text, setText] = useState({
        transport: "",
        valueTransport: "",
        driver: "",
        valueDriver: ""
    });

    useEffect(() => {
        getDataAll();
    }, []);

    useEffect(() => {
        if (selectedTonnelage) {
            dispatch(getTransport({ idTransportType: selectedTonnelage, isActive: true, Export: true }));
        }
    }, [selectedTonnelage]);

    useEffect(() => {
        if (text.transport && text.transport.idProvider) {
            getData();
             if (text.transport && selectedDpEnd && selectedDpStart) {
                const coordinates = getCoordinates(selectedDpStart, selectedDpEnd);
                getMapRoutes(coordinates);
            }
        }
    }, [text.transport, selectedDpEnd, selectedDpStart]);

    useEffect(() => {

        if ( selectedDivision && selectedClient ) {
            let body = {
                customerId: selectedClient,
                divisionId: selectedDivision
            }
           dispatch(getRouteIdDPStart(body));
        } 
      
    }, [ selectedDivision, selectedClient ]);

    useEffect(() => {
      if ( selectedMunicipally ) {
            let body = {
                customerId: selectedClient,
                divisionId: selectedDivision,
                muniId: selectedMunicipally
            }
            dispatch(getRouteIdDPEnd(body));
        }
    }, [selectedMunicipally])
    
    useEffect(() => {
        
        if ( selectedDpStart && selectedDpEnd ){
            const coordinates = getCoordinates(selectedDpStart, selectedDpEnd);
            getMapRoutes(coordinates);
        }
        
    }, [selectedDpStart, selectedDpEnd]);
    
    const getData = () => {
        dispatch(getDriver({ idProvider: text.transport.idProvider, isActive: true, Export: true }))
    };

    const getDataAll= () => {
        dispatch(getClient({ Export: true }));
        dispatch(getFuel({ Export: true }));
    };
    
    const handleClientChange = (newClient, formik) => {
        //dispatch(getRouteIdDPStart(newClient));
        setSelectedClient(newClient)
        formik.setFieldValue("clients", newClient);
        formik.setFieldValue("idStartDP", "");
        formik.setFieldValue("idEndDP", "");
        setSelectedDpStart("");
        setSelectedDpEnd("");
    };

    const HandleDivisionSelected = (division, formik) => {

        formik.setFieldValue("idStartDP", ""); 
        formik.setFieldValue("division", division);
        setText(prevState => ({...prevState, transport:"", valueTransport: "" }));
        setSelectedDivision(division);
        setSetlectedMunicipally("");
        setSelectedDpStart("");
        setSelectedDpEnd("");
    };

    const HandleTonnelageSelected = (tonnelage, formik) => {

        formik.setFieldValue("tonnelage", tonnelage);
        setText(prevState => ({...prevState, transport:"", valueTransport: ""}));
        setSelectedTonnelage(tonnelage);
    };

    const handleDPStartChange = (newDpStart, formik) => {

        const finalPoint = deliveryPointStart.data.filter((item) => item.idDeliveryPoint === newDpStart)
        setSetlectedMunicipally(Number(finalPoint[0].muniId))
        setSelectedDpStart(newDpStart);
        formik.setFieldValue("idEndDP", ""); 
    };

    const handleDPEndChange = (newDpEnd, formik) => {
        setSelectedDpEnd(newDpEnd);
    };

    const handleSubmit = (modal, formik) => {
        if ( modal === 'transport') {
            setText((prevText) => ({ ...prevText, driver: "", valueDriver:""}));
        }
        setOpenModal((prev) => ({ ...prev, [modal]: true, formik: formik }));
    };
    
    const handleCallback = (value, indice) => {
        setOpenModal((prev) => ({ ...prev, driver: false, transport: false }))
        if (indice === 'driver') {
            openModal.formik.setFieldValue("idDriver", value.idDriver);
            setText((prevText) => ({ ...prevText, driver: value, valueDriver: `${value.license} | ${value.name}` }));
        } else if (indice === 'transport') {
            openModal.formik.setFieldValue("idTransport", value.idTransport);
            setText((prevText) => ({ ...prevText, transport: value, valueTransport: `${value.comercialName} | ${value.transportType} | ${value.division}` }));
        }
    };

    const getCoordinates = (selectedDpStart, selectedDpEnd) => {
        let startResult;
        let endResult;
    
        if (selectedDpStart) {
            // Buscar el punto de entrega de inicio
            startResult = find(deliveryPointStart?.data, ({ idDeliveryPoint }) => idDeliveryPoint === selectedDpStart) || {};
            const { latitude: startLatitude, longitude: startLongitude } = startResult;
        }
    
        if (selectedDpEnd) {
            // Buscar el punto de entrega de fin
            endResult = find(deliveryPointEnd?.data, ({ idDeliveryPoint }) => idDeliveryPoint === selectedDpEnd) || {};
            const { latitude: endLatitude, longitude: endLongitude } = endResult;
        }

        return {startResult,  endResult};
    };    

    const getMapRoutes = async ( coords ) => {

        if (coords && text.transport) {

          let transport = text.transport;
          let priceTypeFuel = fuel.data.data;
          const fuelPrice = priceTypeFuel.filter(price => price.fuelType === transport.idTransportFuelType);
          
          const sortedFuels = fuelPrice.sort((a, b) => b.idFuel - a.idFuel);

          let { latitude: originLat, longitude: originLng } = coords.startResult;
          let { latitude: destinationLat, longitude: destinationLng } = coords.endResult;
          
          let origin = { latitude: originLat, longitude: originLng }; 
          let destination = { latitude: destinationLat, longitude: destinationLng };

          const kms = await calculateKilometers(origin, destination)
          const retorno = await calculateKilometers(destination, origin)
          let kiloXGallon = text.transport.kiloXGallon;
          const priceFuel = sortedFuels[0].price;
          let totalKm = Number(retorno) + Number(kms);
          let gal = (totalKm / kiloXGallon);
          let cost = gal * priceFuel;
          setTotalfuel(cost.toFixed(2));
          fuelCost.current = { kiloXGallon, priceFuel, kms: totalKm, gal, cost: roundPrice(cost.toFixed(2)) }

        } else {

            let { latitude: originLat, longitude: originLng } = coords.startResult;
            let { latitude: destinationLat, longitude: destinationLng } = coords.endResult;
            
            let origin = { latitude: originLat, longitude: originLng }; 
            let destination = { latitude: destinationLat, longitude: destinationLng };

            const kms = await calculateKilometers(origin, destination)
            const retorno = await calculateKilometers(destination, origin)
            let totalKm = Number(retorno) + Number(kms);
            setKmEstimate(totalKm);
        }
      };

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }
    const closeNoti = (e) => {
        setShowNoti(e)
        dispatch(postRouteReset())
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "error",
                title: "Uno o más errores de validación han ocurrido.",
                subtitle: (<li>{` ${get(err, "ErrorMessage")}`}</li>),
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
        }
    }
    
    const onSubmit = (values) => {
        const body = {
            comments: get(values, "comments"),
            dateToRoute: moment(get(values, "dateToRoute")).format(),
            idTransport: get(text, "transport.idTransport") ? Number(get(text, "transport.idTransport")) : null,
            idDriver: get(text, "driver.idDriver") ? Number(get(text, "driver.idDriver")) : null,
            idRouteStatus: Number(get(values, "idRouteStatus")),
            idEndDP: Number(get(values, "idEndDP")),
            idStartDP: Number(get(values, "idStartDP")),
            customerId: String(selectedClient),
            kilometersEstimate: Number(kmEstimate),
            fuelCost: Number(get(fuelCost, "current.cost")),
            fuelGallons: Number(get(fuelCost, "current.kiloXGallon")),
            divisionId: Number(selectedDivision),
            idTransportType: Number(selectedTonnelage),
            idRouteType: Number(get(values, "idRouteType")),
        }
        dispatch(postRoute(body));
    };
    
    const initialValues = {
        comments: "",
        dateToRoute: new Date(),
        isActive: id ? get(current, "data.isActive", "") : true,
        idTransport: "",
        idDriver: "",
        idRouteStatus: 1,
        routeStatus: get(find(routeStatus, ({ value }) => value === 1), "label"),
        idEndDP: "",
        idStartDP: "",
        idUser: get(user, "idUser"),
        kilometersEstimate: "",
        clients: "",
        division: "",
        tonnelage: "",
        idRouteType: "",
    }
        
    const evaluateCoord = (idDP, v) => {
        const { latitude, longitude } = find(deliveryPointStart?.data, ({ idDeliveryPoint }) => idDeliveryPoint === idDP) || find(deliveryPointEnd?.data, ({ idDeliveryPoint }) => idDeliveryPoint === idDP) || {}
        if ((!!latitude && !!longitude) || !idDP) {
            return false
        } else {
            return true
        }
    }
    
    const getCoords = (start, end) => {
        const coords = []
        if (!!start) {
            const coordStart = {
                location: {
                    id: 1,
                    lat: Number(get(find(deliveryPointStart.data, ({ idDeliveryPoint }) => idDeliveryPoint === start), "latitude", "")),
                    lng: Number(get(find(deliveryPointStart.data, ({ idDeliveryPoint }) => idDeliveryPoint === start), "longitude", "")),
                }
            }
            coords.push(coordStart)
        }
        if (!!end) {
            const coordEnd = {
                location: {
                    id: 2,
                    lat: Number(get(find(deliveryPointEnd.data, ({ idDeliveryPoint }) => idDeliveryPoint === end), "latitude", "")),
                    lng: Number(get(find(deliveryPointEnd.data, ({ idDeliveryPoint }) => idDeliveryPoint === end), "longitude", "")),
                }
            }
            coords.push(coordEnd)
        }
        return coords;
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/transactions/routes/${get(post, "id")}`) }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post"); }
    }, [post])
    
    return (
        <Layout
        propsToolbar={{
            title: __(`head.new.name`),
            srute: __(`head.new.code`),
            }}
        >
            <div>
                {false
                    ? (
                        <Skeleton />
                    ) : (
                        <Formik initialValues={initialValues} 
                        validationSchema={validator(__)} 
                        onSubmit={onSubmit}>
                            {formik => (
                                <form onSubmit={get(formik, "handleSubmit")}>
                                    <Paper className='p-4'>
                                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                                            <LoadingButton variant="contained" color="secondary" startIcon={<SaveIcon/>} type="submit" loading={get(post, "isLoading") || get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                            <Button variant='outlined' color="secondary" onClick={() => navigate("/transactions/routes")} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                        </Stack>
                                    </Paper>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={6}>
                                            <Paper className='mt-4' >
                                                <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                                                    <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                                    <InputTextDetail
                                                        name={"routeStatus"}
                                                        formik={formik}
                                                        label=""
                                                        placeholder=""
                                                        disabled={!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        fullWidth={false}
                                                        sx={{ "fieldset": { borderColor: `#21EB21 !important` }, "& .Mui-disabled": { "-webkit-text-fill-color": `#21EB21 !important` } }}
                                                        />
                                                </Stack>
                                                <Divider />
                                                <Box className='p-4' >
                                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                                        <Grid item xs={12}>
                                                            <Autocomplete
                                                                name="clients"
                                                                formik={formik}
                                                                label={__(`form.clients.label`)}
                                                                placeholder={__(`form.clients.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(put, "isLoading", false) || get(post, "isLoading", false)} 
                                                                options={clients}
                                                                value={clients.find(option => option.value === formik.values.clients || null)} 
                                                                onChange={(event, value) => handleClientChange(value ? value.value : null, formik)} 
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Autocomplete
                                                                formik={formik}
                                                                name="idRouteType"
                                                                label={__(`form.idRouteType.label`)}
                                                                placeholder={__(`form.idRouteType.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                                options={routesTypes}
                                                                />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Autocomplete
                                                                name="division"
                                                                formik={formik}
                                                                label={__(`form.division.label`)}
                                                                placeholder={__(`form.division.placeholder`)}
                                                                options={divisions}
                                                                onChange={(event, value) => HandleDivisionSelected(value.value, formik)} 
                                                                disableClear={true}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Autocomplete
                                                                name="tonnelage"
                                                                formik={formik}
                                                                label={__(`form.tonnelage.label`)}
                                                                placeholder={__(`form.tonnelage.placeholder`)}
                                                                options={transportTypes}
                                                                onChange={(event, value) => HandleTonnelageSelected(value.value, formik)} 
                                                                disableClear={true}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <AutoComplete2
                                                                name={"idStartDP"}
                                                                formik={formik}
                                                                label={__(`form.idStartDP.label`)}
                                                                placeholder={__(`form.idStartDP.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(put, "isLoading", false) || get(post, "isLoading", false)}
                                                                options={selectedClient && selectedDivision ? deliveryPointsStart : [] }
                                                                reload={get(deliveryPointStart, "isLoading")}
                                                                loading={get(deliveryPointStart, "isLoading")}
                                                                setIsMount={setIsMount}
                                                                disableClear={true}
                                                                value={deliveryPointsStart.find(option => option.value === formik.values.idStartDP) || null} 
                                                                getOptionDisabled={(option) => evaluateCoord(option.value, 1)}
                                                                getOptionLabel={({ label, value }, v) => 
                                                                    value ? (
                                                                        evaluateCoord(value) ? 
                                                                            <Stack direction="row" spacing={1} alignItems="center"><LocationOffIcon /><div>{label}</div></Stack> 
                                                                        : label
                                                                    ) : '' 
                                                                }
                                                                callback={(event, value) => handleDPStartChange(value.value, formik, value)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <AutoComplete2
                                                                name={"idEndDP"}
                                                                formik={formik}
                                                                label={__(`form.idEndDP.label`)}
                                                                placeholder={__(`form.idEndDP.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(put, "isLoading", false) || get(put, "isLoading", false)}
                                                                options={selectedClient && selectedDivision && selectedMunicipally ? deliveryPointsEnd : []}
                                                                reload={get(deliveryPointEnd, "isLoading")}
                                                                loading={get(deliveryPointEnd, "isLoading")}
                                                                value={deliveryPointsEnd.find(option => option.value === formik.values.idEndDP) || null} 
                                                                setIsMount={setIsMount}
                                                                disableClear={true}
                                                                getOptionDisabled={(option) => evaluateCoord(option.value, 1)}
                                                                getOptionLabel={({ label, value }, v) => 
                                                                    value ? (
                                                                        evaluateCoord(value) ? 
                                                                            <Stack direction="row" spacing={1} alignItems="center"><LocationOffIcon /><div>{label}</div></Stack> 
                                                                        : label
                                                                    ) : '' 
                                                                }
                                                                callback={(event, value) => handleDPEndChange(value.value, formik)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <DatePickerUi
                                                                formik={formik}
                                                                name="dateToRoute"
                                                                label={__(`form.dateToRoute.label`)}
                                                                placeholder={__(`form.dateToRoute.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography component="h5" variant="h5" color="text.lite">{__(`labels.3`)}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <InputGroup
                                                                name="idTransport"
                                                                formik={formik}
                                                                label={__(`form.idTransport.label`)}
                                                                placeholder={__(`form.idTransport.placeholder`)}
                                                                onClick={()=> selectedDivision && selectedTonnelage ? handleSubmit('transport', formik) : ""}
                                                                value ={text.valueTransport} 
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <InputGroup
                                                                 name={"idDriver"}
                                                                 formik={formik}
                                                                 label={__(`form.idDriver.label`)}
                                                                 placeholder={__(`form.idDriver.placeholder`)}
                                                                 onClick={() => text.transport ? handleSubmit('driver', formik) : ""}
                                                                 value ={text.valueDriver} 
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography component="h5" variant="h5" color="text.lite">{__(`labels.11`)}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} >
                                                            <InputText
                                                                formik={formik}
                                                                name="comments"
                                                                label={__(`form.comments.label`)}
                                                                placeholder={__(`form.comments.placeholder`)}
                                                                disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                                multiline
                                                                rows={3}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12} lg={6}>
                                            <Paper className='mt-4 p-4 flex h-full flex-col' sx={{ height: 500 }}>
                                                {getCoords(get(formik, "values.idStartDP"), get(formik, "values.idEndDP"))?.length > 1 &&
                                                    <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                                        {kmEstimate !== 0 && (
                                                            <Typography component="h4" variant="h4">
                                                                {__(`labels.4`)} 
                                                                {/* {km && ( */}
                                                                    <>
                                                                        <Speed /> {kmEstimate} Km
                                                                    </>
                                                                {/* )} */}
                                                            </Typography>
                                                        )}
                                                        {totalFuel !== 0 && (
                                                            <Typography component="h4" variant="h4">
                                                                <LocalGasStation/> ${totalFuel}
                                                            </Typography>
                                                        )} 
                                                    </Stack>
                                                }
                                                {
                                                    getCoords(get(formik, "values.idStartDP"), get(formik, "values.idEndDP"))?.length > 1
                                                        ? <MapToNew coords={map(getCoords(get(formik, "values.idStartDP"), get(formik, "values.idEndDP")), ({ location: { lat, lng } }) => ({ lat, lng }))} getKm={setKm} __={__} />
                                                        : <MapOne position={getCoords(get(formik, "values.idStartDP"), get(formik, "values.idEndDP"))[0]?.location} __={__} disableInput />
                                                }
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </form> 
                            )}
                        </Formik>
                    )}
                    <TransportModal
                        __={__}
                        open={openModal.transport}
                        division = {selectedDivision}
                        tonnelage = {selectedTonnelage}
                        close={() => setOpenModal((prev) => ({ ...prev, transport: false}))}
                        callback={(value) => handleCallback (value, 'transport')}
                        showNoti={showNoti}
                        setShowNoti={setShowNoti}
                        alert={alert}
                        setAlert={setAlert}
                    />
                    <DriverModal
                        __={__}
                        open={openModal.driver}
                        id={text.transport.idProvider}
                        close={() => setOpenModal((prev) => ({ ...prev, driver: false }))}
                        callback={(value) => handleCallback (value, 'driver')}
                    />
                <Notification __={__} showNoti={showNoti} setShowNoti={closeNoti} />
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </div>
        </Layout>
    )
}

export default NewEdit